interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
  ogImage?: string;
  ogType?: string;
  schemas?: Record<string, unknown>[];
  noindex?: boolean;
  ogUrl?: string;
  lastModified?: string;
}

export default function SEO({
  title,
  description,
  keywords,
  canonical,
  ogImage = "https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=1200&h=630&fit=crop&q=80",
  ogType = "website",
  schemas = [],
  noindex = false,
  ogUrl,
  lastModified = "2026-05-24",
}: SEOProps) {
  const fullTitle = title.includes("ExpertAdvise")
    ? title
    : `${title} | ExpertAdvise.in`;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      {canonical && <link rel="canonical" href={canonical} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <meta name="last-modified" content={lastModified} />

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={ogUrl || canonical || "https://expertadvise.in"} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="ExpertAdvise.in" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@expertadvise" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {schemas.map((schema, idx) => (
        <script
          key={idx}
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schema),
          }}
        />
      ))}
    </>
  );
}